$(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
});

//bootstrap Tabs
$(document).ready(function () {
    $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        localStorage.setItem('activeTab', $(e.target).attr('href'));
    });

    let activeTab = localStorage.getItem('activeTab');
    if (activeTab) {
        $('.tab-list a[href="' + activeTab + '"]').tab('show');
    }

    $('.nav-link').on('click', function () {
        if (localStorage.getItem('activeTab') != null) {
            localStorage.removeItem('activeTab')
        }
    })

    $('.back-btn').on('click', function () {
        if (localStorage.getItem('activeTab') != null) {
            localStorage.removeItem('activeTab')
        }
    })
});

// A jQuery plugin to determine when a form has been modified (dirtied) and act accordingly
require('jquery.dirty')
$(document).ready(function () {
    setTimeout(function () {
        initializeDirtyPlugin()
    }, 1500);
    //Autofocus and highlight a given input/text element. Only one per page.
    let autofocusElement = $('.autofocus-element');
    autofocusElement.focus();
    autofocusElement.select();
});

function initializeDirtyPlugin() {
    $('.ajax-form').each(function (index, element) {
        $(element).dirty({
            preventLeaving: !$(element).hasClass('ignore-dirty'),
            onDirty: function () {
                if(!$(element).hasClass('ignore-dirty')) $(element).addClass('dirty');
            },
            onClean: function () {
                $(element).removeClass('dirty');
            }
        })
    })

    //Autofocus and highlight a given input/text element. Only one per page.
    let autofocusElement = $('.autofocus-element');
    autofocusElement.focus();
    autofocusElement.select();

    setTimeout(function () {
        $('input[type="text"]').attr('autocomplete', 'off');
    }, 500);
}

Livewire.on('submit-livewire-form', function () {
    $('.set-clean-on-livewire-submit').each(function (index, element) {
        $(element).dirty("setAsClean");
    })
})

// Textarea as a texteditor
window.tinymce = require('./tinymce.min');
require('./tinymce.min');
var readonly = typeof isViewPage !== 'undefined' ? isViewPage : false;
tinymce.init({
    selector: '.customer-editor',
    oninit: "setPlainText",

    plugins: "nonbreaking, autoresize, directionality, paste",
    menubar: 'insert',
    toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent",

    paste_as_text: true,
    nonbreaking_force_tab: true,
    force_br_newlines: true,
    force_p_newlines: false,
    forced_root_block: '',
    readonly: readonly,

    autoresize_bottom_margin: 50,

    setup: editor => {
        editor.on('init', (e) => {

            // Set cursor position to end of text if autofocus property is set
            if (e.target.targetElm.autofocus) {
                e.target.selection.select(tinyMCE.activeEditor.getBody(), true);
                e.target.selection.collapse(false);
                e.target.focus();
            }

            // Autoresize the editor
            editor.execCommand('mceAutoResize');
        });
        editor.on('keydown', (e) => {
            setDirty(e);
        });
    },
});

function setDirty(e) {
    const dirtyForm = $($(e.relatedTarget).attr('href')).find('.ajax-form');
    dirtyForm.dirty("setAsDirty");
}

// Prevent tab changing if there are changes on form
$('a[data-toggle="tab"]').on('show.bs.tab', function (event) {
    const dirtyForm = $($(event.relatedTarget).attr('href')).find('.ajax-form');

    if (dirtyForm != null && dirtyForm.hasClass("dirty")) {
        if (confirm('Hier sind ungespeicherte Änderungen, die verloren gehen könnten. Wollen Sie fortfahren?')) {
            dirtyForm.dirty('setAsClean');
            dirtyForm.removeClass('dirty');
        } else {
            event.preventDefault();
        }
    }
});

// Customer - blocked-> show reason and date
$(function () {
    $("#blocked").click(function () {
        if ($(this).is(":checked")) {
            $(".blocked-info-empty").removeClass('invisible');
            $('#blocked_reason').val('');
            $('#blocked_date').val(new Date().toISOString().replace(/T.*/, '').split("-").reverse().join("."));
            $('#blocked_reason').prop('readonly', false);
        } else {
            $(".blocked-info-empty").addClass('invisible');
            $('#blocked_reason').prop('readonly', true);
        }
    });
});

//for update validation
$(function () {
    $(".nav-link").click(function () {
        setLoadedTime();
    });
});

$(document).ready(function () {
    setLoadedTime();
});

function setLoadedTime() {
    let dateTime = moment().format("YYYY-MM-DD HH:mm:ss");
    localStorage.setItem('loadedTime', dateTime);
}

// search-field -> close box by outside click / show all results, if toggled
document.addEventListener('click', function handleClickOutsideBox(event) {
    let self = $(event.target);
    if (!$.contains($(".results-box"), self) && !self.hasClass('show-all-results')) {
        $(".results-box").hide();
    } else if (self.hasClass('show-all-results')) {
        self.addClass('d-none');
        self.parent().siblings('.extra-results').removeClass('d-none');
        $('.results-count').addClass('d-none');
    }
});

//disable enter to save the forms
window.addEventListener('keydown', function (e) {
    if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) {
        if (e.target.nodeName == 'INPUT' && e.target.type == 'text') {
            e.preventDefault();
            return false;
        }
    }
}, true);

//disable autocomplete on inputs
$(document).ready(function () {
    $('input').attr('autocomplete', 'off');
    $('input[type="password"]').attr('autocomplete', 'new-password');
});

// fit textarea height to their content
$(document).ready(function () {
    const textarea = $('textarea.dynamic-height');

    textarea.each(function () {
        $(this).parent().attr('data-replicated-value', $(this).val());
    })

    textarea.on('input', function () {
        $(this).parent().attr('data-replicated-value', $(this).val());
    })
});

$(function () {
    $("#maintenance_assignment").click(function () {
        if ($(this).is(":checked")) {
            $(".empty_maintenance_assignment").removeClass('d-none');
            $('#maintenance_assignment_text').val('');
        } else {
            $(".empty_maintenance_assignment").addClass('d-none');
        }
    });
})

$(function () {
    $("#planned_work").click(function () {
        if ($(this).is(":checked")) {
            $(".empty_planned_work_text").removeClass('d-none');
            $('#planned_work_text').val('');
        } else {
            $(".empty_planned_work_text").addClass('d-none');
        }
    });
})

$(function () {
    $("#planning_contract").click(function () {
        if ($(this).is(":checked")) {
            $(".empty_planning_contract").removeClass('d-none');
            $('#planning_contract_text').val('');
        } else {
            $(".empty_planning_contract").addClass('d-none');
        }
    });
})

//if checkbox is checked, show input field for email
$(function () {
    $("#invoice_per_email").click(function () {
        if ($(this).is(":checked")) {
            $(".empty_invoice_per_email").removeClass('d-none');
            $('#invoice_per_email_text').val('');
        } else {
            $(".empty_invoice_per_email").addClass('d-none');
        }
    });
})

// Show preview of file on upload
$(function () {
    $("#user_signature,#agb_upload,#technical_advice_upload").on('change', function (e) {
        if (e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                $('.preview').attr('src', e.target.result);
            }
            $(e.target).next('.preview').removeClass('d-none');
            reader.readAsDataURL(e.target.files[0]);
        }
    });
})

$(document).ready(function () {
    $('.sidebar-heading').click((e) => {
        $(e.target).closest('.sidebar-heading').find('i').toggleClass('flip');
    });
});


// Scroll to selected table row
$(document).ready(function () {
    const element = document.getElementsByClassName("is-selected")[0];

    if (element != null)
        element.scrollIntoView();
});

// Email template autofill editor
$('#email_template').on('change', function (e) {
    let optionSelected = $("option:selected", this);
    let valueSelected = this.value;
    if (valueSelected) {
        tinymce.activeEditor.setContent(optionSelected.data('text'));
    } else {
        tinymce.activeEditor.setContent("");
    }
});

//------------------------------------------------------------------------------------------|
// Custom Searchable drop down input                                                        |
//------------------------------------------------------------------------------------------|
$('.searchable-dropdown').on("click", ".menu-item", function () {
    $("#component").val($(this).text());
});

$('.dropdown').on("input", "#component", function () {
    let input = $(this).val().toLowerCase();
    $(".searchable-dropdown li").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(input) > -1)
    });
});

$('.searchable-dropdown').on("click", ".dropdown-toggle", function (e) {
    e.stopPropagation();
    $(".searchable-dropdown").toggle();
});
//------------------------------------------------------------------------------------------|

//------------------------------------------------------------------------------------------|
// switch between two input sets of in a form                                               |
//------------------------------------------------------------------------------------------|
// This allows you to have multiple radio buttons corresponding to fieldsets, which activate|
// or deactivate them. The names have to be the same for the optionsset, the id can differ  |
// the id of the radio button should correspond to the class of the fieldset to toggle it   |
//------------------------------------------------------------------------------------------|
$('.radio-switcher').on("click", function () {
    let optionSet = this.name;
    $('.radio-switcher').each((index, radio) => {
        if(radio.name == optionSet) {
            $('.' + radio.id).attr('disabled', function (i, r) {
                return !radio.checked;
            });
        }
    })
});
//------------------------------------------------------------------------------------------|

//-----------------------------------|
// Custom Disable function for inputs|
//-----------------------------------|
$('.disableable-toggler').on("click", function () {
    if ($(this).data('disable')) {
        let disableId = $(this).data('disable');
        $("."+disableId).attr('disabled', function (i, r) {
            return !r;
        });
    }else{
        $(".disableable").attr('disabled', function (i, r) {
            return !r;
        });
    }
});
//------------------------------------|
// Custom Readonly function for inputs|
//------------------------------------|
$('.readonly-toggler').on("click", function () {
    $(".readonly").attr('readonly', function (i, r) {
        return !r;
    });
});
//-----------------------------------|
